export class ProjectGroupPermissionListing{
    public admin: boolean = false;
    public permission: string;
    public group: string[];
}